module.exports = __webpack_public_path__ + "img/zunge-zb.c3c84d46.svg";